import { AxiosClient } from "./AxiosClient";

export const getUserFirstLast = () => {
  try {
    return AxiosClient.get("feed/getUserFirstLast");
  } catch (e) {
    console.log(e);
  }
};

export const createTicket = (ticket_data, media) => {
  try {
    return AxiosClient.post("tickets/createTicket", { ticket_data, media });
  } catch (e) {
    console.log(e);
  }
};

export const addNewTicketData = (
  ticket_id,
  ticket_data,
  media,
  ticket_status,
) => {
  try {
    return AxiosClient.post("tickets/addNewTicketData", {
      ticket_id,
      ticket_data,
      media,
      ticket_status,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAllUsersTickets = () => {
  try {
    return AxiosClient.post("tickets/getAllUsersTickets", {});
  } catch (e) {
    console.log(e);
  }
};

export const deleteTicket = (ticket_id) => {
  try {
    return AxiosClient.post("tickets/deleteTicket", { ticket_id });
  } catch (e) {
    console.log(e);
  }
};

export const fileUpload = (file) => {
  try {
    return AxiosClient.post("chat/fileUpload", file);
  } catch (e) {
    console.log(e);
  }
};

export const getTickets = () => {
  try {
    return AxiosClient.post("tickets/getTickets", {});
  } catch (e) {
    console.log(e);
  }
};

export const getTicketThread = (ticket_id) => {
  try {
    return AxiosClient.post("tickets/getTicketThread", { ticket_id });
  } catch (e) {
    console.log(e);
  }
};

export const getUserType = () => {
  try {
    return AxiosClient.get("auth/getUserType");
  } catch (e) {
    console.log(e);
  }
};

export const getUsersTimeSaved = (pastMonths) => {
  try {
    return AxiosClient.post("chat/getUsersTimeSaved", { pastMonths });
  } catch (e) {
    console.log(e);
  }
};

export const adminNewUser = (
  email,
  mfa_email,
  first_name,
  last_name,
  role,
  password,
) => {
  try {
    return AxiosClient.post("auth/signupNewUser", {
      email,
      mfa_email,
      first_name,
      last_name,
      role,
      password,
    });
  } catch (e) {
    console.log(e);
  }
};

export const adminLockAccount = (email) => {
  try {
    return AxiosClient.post("auth/lockAccount", { email });
  } catch (e) {
    console.log(e);
  }
};

export const adminResetPassword = (email, newPassword) => {
  try {
    return AxiosClient.post("auth/resetPassword", { email, newPassword });
  } catch (e) {
    console.log(e);
  }
};

export const adminUpdateAccount = (email, updateField, updateAttribute) => {
  try {
    return AxiosClient.post("auth/updateUserAccountAdmin", {
      email,
      updateField,
      updateAttribute,
    });
  } catch (e) {
    console.log(e);
  }
};

export const userUpdateAccount = (updateField, updateAttribute) => {
  try {
    return AxiosClient.post("auth/updateUserAccount", {
      updateField,
      updateAttribute,
    });
  } catch (e) {
    console.log(e);
  }
};

export const userUpdatePassword = (password, newPassword) => {
  try {
    return AxiosClient.post("auth/userUpdatePassword", {
      password,
      newPassword,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAllUsers = () => {
  try {
    return AxiosClient.post("auth/getAllUsers", {});
  } catch (e) {
    console.log(e);
  }
};

export const getMfaToggle = () => {
  try {
    return AxiosClient.get("settings/getMfaToggle");
  } catch (e) {
    console.log(e);
  }
};

export const updateMfa = (mfa) => {
  try {
    return AxiosClient.post("settings/updateMfa", { mfa });
  } catch (e) {
    console.log(e);
  }
};

export const getLightDarkMode = () => {
  try {
    return AxiosClient.get("settings/getLightDarkMode");
  } catch (e) {
    console.log(e);
  }
};

export const updateLightDarkMode = (dark_mode) => {
  try {
    return AxiosClient.post("settings/updateLightDarkMode", { dark_mode });
  } catch (e) {
    console.log(e);
  }
};

export const getLitellmModels = () => {
  try {
    return AxiosClient.get("settings/getLitellmModels");
  } catch (e) {
    console.log(e);
  }
};

export const getPublicModels = () => {
  try {
    return AxiosClient.get("settings/getPublicModels");
  } catch (e) {
    console.log(e);
  }
};

export const updatePublicModel = (
  provider,
  credentials,
  enabled,
  enabled_models,
  active_model,
) => {
  try {
    return AxiosClient.post("settings/updatePublicModel", {
      provider,
      credentials,
      enabled,
      enabled_models,
      active_model,
    });
  } catch (e) {
    console.log(e);
  }
};

export const deletePublicModel = (provider) => {
  try {
    return AxiosClient.post("settings/deletePublicModel", { provider });
  } catch (e) {
    console.log(e);
  }
};

export const getActiveModel = () => {
  try {
    return AxiosClient.get("settings/getActiveModel");
  } catch (e) {
    console.log(e);
  }
};
